import { graphql } from 'gql';

export const uerActKC2VolumeVariableSelectionItemsGql = graphql(`
    query uerActKC2VolumeVariableSelectionItems(
        $skip: Int
        $take: Int
        $actKC2Id: Long!
        $workOrderPriceId: Long!
        $where: ActKC2VolumeVariableSelectionItemFilterInput
    ) {
        uerActKC2VolumeVariableSelectionItems(
            skip: $skip
            take: $take
            workOrderPriceId: $workOrderPriceId
            actKC2Id: $actKC2Id
            where: $where
        ) {
            totalCount
            items {
                uniqueId
                name
                coefficients
                isUer
                isMtr
            }
        }
    }
`);

export const uerActKC2SmrValueGql = graphql(`
    query uerActKC2SmrValue($actKC2Id: Long!, $workOrderPriceId: Long!) {
        uerActKC2SmrValue(actKC2Id: $actKC2Id, workOrderPriceId: $workOrderPriceId) {
            data {
                id
                formula
            }
        }
    }
`);

export const uerSetActKC2FormulaGql = graphql(`
    mutation uerSetActKC2Formula($actKC2Id: Long!, $workOrderPriceId: Long!, $formula: String) {
        uerSetActKC2Formula(actKC2Id: $actKC2Id, workOrderPriceId: $workOrderPriceId, formula: $formula) {
            result
            data
            message
            validation {
                property
                message
                metadata
            }
        }
    }
`);
